import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { getAuthReducer } from '../../../../../../../redux/reducers/reducerSlices/AuthReducer';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { formatContactNumNNN, initiateSearch, showAlert, getMobileNumber } from '../../../../../../Assests/Utility';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import DrilldownTableSS from '../../../../../LandingPage/Components/Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import CustomButtonSS from '../../../../../Common/CustomButton/CustomButtonSS';
import CommonToggleSwitch from '../../../../../Common/CommonToggleSwitch/CommonToggleSwitch';
import EditIcon from '../../../../../../Assests/Images/edit-icon-new.png'
import { toast } from 'react-toastify';
import CustomTooltip from '../../../../../Common/Tooltip/CustomTooltip';

const UserTableSS = (props) => {
    const { themeSelected, allowPermissionED, editUserAction, searchStr, } = props;
    const [userListData, setUserListData] = useState([]);
    const user = useSelector(getUserSelector)
    const { initateLoading, userList, carrierSubUserList, userType, arrangeOrder, arrangeKey, cu_id, userAccountDetails, actionLoader } = user;
    const userAuth = useSelector(getAuthReducer);
    const { user_name } = userAuth;
    const dispatch = useDispatch()
    const [currentIndex, setCurrentIndex] = useState(null)


    useEffect(() => {
        dispatch({ type: sagaActions.INITIATE_LOADING, payload: true })
        dispatch({ type: sagaActions.UPDATE_CARRIER_SUB_USER, payload: createPayload() })
    }, [])

    useEffect(() => {
        setCurrentIndex(null);
        if (carrierSubUserList) {
            initateLoading && dispatch({ type: sagaActions.INITIATE_LOADING, payload: false })
            if (searchStr) {
                const searchedArr = initiateSearch(carrierSubUserList, searchStr, 'UserName');
                setUserListData(searchedArr);
            } else {
                setUserListData(carrierSubUserList);
            }
        }
    }, [carrierSubUserList])

    useEffect(() => {
        if (searchStr.length > 3) {
            const searchedArr = initiateSearch(carrierSubUserList, searchStr, 'UserName');
            setUserListData(searchedArr);
        } else if (searchStr === '') {
            setUserListData(carrierSubUserList)
        }
    }, [searchStr])


    const createPayload = () => {
        return {
            UserName: "",
            Email: "",
            CreatedBy: "",
            UpdatedBy: "",
            EnableStatus: null,
            CUID: "",
            CRUDTYPE: "S",
            LastName: "",
            FirstName: "",
            phone: "",
            IDCarrier: userAccountDetails.IDCarrier,
            CarrierName: "",
            PrimaryUserCUID: cu_id,
            SMSAccess: true
        }
    }

    const warehouseTitleDD = [
        { id: 'serial_num', name: 'S.No' },
        { id: 'UserName', name: 'Username' },
        { id: 'Email', name: 'Email' },
        { id: 'FirstName', name: 'First Name' },
        { id: 'LastName', name: 'Last Name' },
        { id: 'Phone', name: 'Phone Number' },
        { id: 'CreatedOn', name: 'Created on' },
        // { id: 'SMSAccess', name: 'SMSAccess' },
        { id: 'actions', name: 'Actions' },
    ]

    // Click handler for action button - EDIT/DELETE/ASSIGN
    const clickHandler = (key, user) => {
        const updatedRow = { ...user, SMSAccess: !user.SMSAccess, CRUDTYPE: 'U', PrimaryUserCUID: user.CreatedBy, phone: user.Phone };
        dispatch({ type: sagaActions.UPDATE_CARRIER_SUB_USER, payload: updatedRow })
    }
    const disableUserAction = (data, status) => {
        if ((data.EnableStatus === 0 || data.EnableStatus === false) && allowPermissionED() >= 2) {
            showAlert(toast.TYPE.ERROR, AppConstant.commonStrings.carrierSubUserLimitExceed, themeSelected)
        }
        else {
            setCurrentIndex(data.UserID)
            const finalData = { ...data }
            finalData.EnableStatus = finalData.EnableStatus ? 0 : 1;
            finalData.CRUDTYPE = 'U';
            finalData.PrimaryUserCUID = data.PrimaryUserID;
            finalData.phone = data.Phone
            dispatch({ type: sagaActions.UPDATE_CARRIER_SUB_USER, payload: finalData })
        }
    }


    const actionsButton = (el) => {
        return (
            <div className='d-flex flex-row align-items-center'>
                <span className='px-1'>
                    <img src={EditIcon} alt='edit' className='editIconPO-ss'
                        dataBsToggle="modal"
                        dataBsTarget={`#createUserFormPopup`}
                        disabled={false}
                        onClick={() => editUserAction(el)}
                    />
                </span>


                <span className={true ? 'px-1 pt-1' : 'px-1 disabled'} data-tip={"SMS Access"} data-for='SMS Access'>
                    <input
                        type='checkbox'
                        value={el?.SMSAccess}
                        name='SMSAccess'
                        className={'customTextInputError'}
                        checked={el?.SMSAccess}
                        // onBlur={(data) => props.handleErrors(data.target.name)}
                        onChange={() => { clickHandler(AppConstant.commonStrings.SMSAccess, el) }}
                        disabled={el?.EnableStatus ? false : true}
                    />
                    <CustomTooltip id='SMS Access' position='bottom' type='light' multiline={true} html={true} />
                </span>

                <span className='px-1'>
                    <CustomButtonSS
                        onClick={() => { disableUserAction(el) }}
                        title={el.EnableStatus ? AppConstant.commonStrings.disable : AppConstant.commonStrings.enable}
                        className={`${el.EnableStatus ? ' btnDisable-ss ' : 'btnEnable-ss'} mx-2`}
                        isLoading={el.UserID === currentIndex ? true : false}
                    />
                </span>
            </div>
        )
    }

    // const smsAccessButton = (el) => {
    //     return (
    //         <div className='d-flex justify-content-center align-items-center'>
    //             <span data-tip={"SMS Access"} data-for='SMS Access' style={{ cursor: el?.EnableStatus ? 'pointer' : 'not-allowed' }}>
    //                 <CommonToggleSwitch
    //                     value={el.SMSAccess}
    //                     allowPermissionD={el?.EnableStatus}
    //                     onChangeValue={() => clickHandler(AppConstant.commonStrings.SMSAccess, el)}
    //                 />
    //             </span>
    //         </div>
    //     )
    // }

    const formatContactNumNNN = (contactNum) => {
        if (!contactNum) return '-';
        
        // Remove all non-digit characters
        let digitsOnly = contactNum.replace(/\D/g, "");
        
        // If more than 10 digits, take only the last 10 (removes country code)
        if (digitsOnly.length > 10) {
            digitsOnly = digitsOnly.slice(-10);
        }
        
        // Format the 10-digit number
        const x = digitsOnly.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ""}`;
    };


    const formatListData = (data) => {
        return data.map((el, index) => {
            return {
                id: `${el.UserID}_${el.LastName}`,
                0: index + 1,
                1: el.UserName || '-',
                2: el.Email,
                3: el.FirstName || '-',
                4: el.LastName || '-',
                5: el.Phone ? formatContactNumNNN(el.Phone) : '-',
                6: el.CreatedOn,
                // 7: smsAccessButton(el),
                7: actionsButton(el),
            }
        })
    }

    return (
        <DrilldownTableSS
            themeSelected={themeSelected}
            bodyData={userListData && userListData?.length ? formatListData(userListData) : []}
            titleData={warehouseTitleDD}
            showCollapse={false}
            showInput={false}
            showSort={true}
            arrangeOrder={arrangeOrder}
            arrangeKey={arrangeKey}
            drillDownReport={userListData}
            initiateDrillDownReport={initateLoading}
            loaderArray={8}
            sortingAction={sagaActions.SORT_USER_TABLE}
            subRoot={{ pathName: 'user' }}
            showUTCTime={false}
        />
    )
}

export default UserTableSS;